import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getAttendance_Report = async(param:any )=>{
   const response = await axiosInstance.get(`${API_ENDPOINTS.Reports.GET_ATTENDANCE_REPORT}`,{params:param});
   const rowData = await response?.data;

   console.log('rowData',rowData?.data);

   const formatedData = Array.isArray(rowData?.data?.data)?
   rowData.data.data.map((item:any)=>({
   EmployeeId:item.EmployeeId,
    EmployeeCode:item.EmployeeCode,
    EmployeeName:item.EmpName,
    AttendanceDate:item.AttendanceDate,
    AttendanceStatus:item.Status,
    CreatedDate:item.CreatedAt,
    StartTime:item.StartTime,
    EndTime:item.EndTime,
    StartLating:item.StartLatlng,
    EndLating:item.EndLatlng,
    Selfie:item.Selfie,
   //  "CreatedDate": "2024-01-15" 
  })):[];   
  return {formatedData,rowData};
}
   